import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const PageHero = ({ eyebrow, title, text, image = "/images/port.jpg", testid }) => (
  <section className="relative overflow-hidden bg-[#0F2840] grain" data-testid={testid}>
    <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0F2840] via-[#0F2840]/85 to-[#0F2840]/30" />
    <div className="relative mx-auto max-w-7xl px-5 py-20 md:py-28 lg:px-8">
      <Reveal>
        <p className="eyebrow !text-[#ff7a7a]">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {text && <p className="mt-6 max-w-xl text-base text-white/75 md:text-lg">{text}</p>}
      </Reveal>
    </div>
    <div className="relative h-3 stripe-mariniere opacity-80" />
  </section>
);
